import React from 'react';
import styles from './_consent-history-dialog.module.scss';
import { ConsentHistoryItem } from '../../../Interfaces/Customer/ConsentHistoryItem';
import { toPng } from 'html-to-image';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { downloadIcon } from '@progress/kendo-svg-icons';

export interface ConsentHistoryDialogProps {
  customerName: string; // name of the customer
  historyItems: ConsentHistoryItem[]; // list of history items to display
  onClose: () => void; // user clicked the close button
}

export default function ConsentHistoryDialog(props: ConsentHistoryDialogProps) {
  // Downloads the given image. Note that we are using a different package here than for the JD Power download. This is because we
  // may need to download overflowing content, and the other package does not seem support that at this time.
  const download = (image: string, { name = `${props.customerName}_consent`, extension = "png" } = {}) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = `${name}.${extension}`
    a.click();
  };

  // Event handler for the download button.
  const downloadScreenshot = () => {
    toPng(document.getElementById('content-container')!, { backgroundColor: 'white', width: document.getElementById('content-container')?.scrollWidth, height: document.getElementById('content-container')?.scrollHeight })
      .then(function (dataUrl) {
        download(dataUrl);
      });
  }
  return (
    <Window
      title="Consent History"
      onClose={props.onClose}
      width={700}
      height={550}
      resizable={true}
      draggable={true}
      modal={true}
    >
      <div className={styles.consentHistoryDialogContainer}>
        <div className={styles.historyItems} id='content-container'>
          {props.historyItems.sort((a, b) => (a.acknowledgementDate || new Date()) > (b.acknowledgementDate || new Date()) ? -1 : 1).map((item: ConsentHistoryItem, index: number) => {
            return (
              <div
                className={styles.historyItem}
                key={index}>
                {item.acknowledgementDate && <div><b>Accepted on</b> {new Date(item.acknowledgementDate).toDateString()}</div>}
                <div><b>IP Address:</b> {item.ipAddress}</div>
                {item.signature && <div><b>Signature:</b> <span style={{ fontFamily: 'cursive' }}>{item.signature}</span></div>}
                <div><b>Acknowledgement:</b> {item.acknowledgementWording}</div>
                {(index < props.historyItems.length - 1) && <hr className={styles.divider} />}
              </div>
            )
          })}
        </div>
      </div>
      <WindowActionsBar>
        <Button
          onClick={downloadScreenshot}
          themeColor="primary"
          fillMode="outline"
        >
          <SvgIcon icon={downloadIcon} size="small" style={{ marginRight: '5px' }} />
          Download
        </Button>
        <Button
          onClick={props.onClose}
          themeColor="primary"
          fillMode="solid"
        >
          Close
        </Button>
      </WindowActionsBar>
    </Window>
  );
}